import React from 'react'
import { RRule, RRuleSet, rrulestr } from 'rrule'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';


import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';

import { validateEmail } from '../../utils/misc'

import { UserApi } from '../../api/usersApi'
// hacer las dos clases:

import Switch from '@material-ui/core/Switch';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import NumberFormat from 'react-number-format';
import Checkbox from '@material-ui/core/Checkbox';

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            thousandSeparator={'.'}
            decimalSeparator={','}
            prefix="$"
        />
    );
}

const styleContact = {
    top: `30%`,
    margin: 'auto',
    width: 300,
    height: 400,
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

const styleAccount = {
    top: `30%`,
    margin: 'auto',
    width: 500,
    height: 500,
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

export class ContactModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            last_name: '',
            DNI: '',
            instagram: '',
            instagram_error_text: null,
            DNI_error_text: null,
            last_name_error_text: null,
            disabled: true,
            open: false,
        };
    }


    isDisabled = () => {
        let instagram_is_valid = false;
        let last_name_is_valid = false;
        let  DNI_is_valid = false;
      
        if (this.state.instagram && this.state.instagram.trim().length >= 2) {
            this.setState({instagram_error_text: null});
            instagram_is_valid =  true
        } else {
            this.setState({instagram_error_text: 'Ingrese un instagram valido'});
        }
       
        if (this.state.DNI && this.state.DNI.toString().length>= 7) {
            this.setState({DNI_error_text:  null  })
            DNI_is_valid = true;
        }
        else  {
            this.setState({DNI_error_text: 'Ingrese un DNI valido',})
        }
        if (this.state.last_name && this.state.last_name.trim().length >= 2) {
            this.setState({last_name_error_text: null});
            last_name_is_valid =  true
        } else {
            this.setState({last_name_error_text: 'Ingrese un apellido valido'});
        }
        this.setState({disabled: !(instagram_is_valid && last_name_is_valid && DNI_is_valid)})

    }

    _handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (!this.state.disabled) {
                this.login(e);
            }
        }
    }
   
    componentWillMount = () => {
        const customer = this.props.customer
        if(customer === null){
            return
        }
        this.setState({
            DNI: customer.dni,
            last_name: customer.last_name,
            instagram: customer.instagram
        })
    }
    update = (e) => {
        e.preventDefault();
        UserApi.updateCustomer(this.props.customer.id,
            this.state.DNI.toString(),
            this.state.instagram.trim(),
            this.state.last_name.trim()
        ).then(_ => {
            this.props.onClose(this.state.DNI,
                               this.state.instagram.trim(),
                               this.state.last_name)
        })
            .catch(error => {
                console.log(error)
            })
    }


    changeValue = (e, type) => {
        let value = e.target.value;
        const next_state = {};
        if(type === 'DNI' && value){
            value = parseInt(value)
        }
        next_state[type] = value;
        this.setState({ type: value })
        this.setState(next_state, () => {
            this.isDisabled();
        });
    }
    handleClickAway = () => {
        this.props.onClose(this.state.DNI,
            this.state.instagram.trim(),
            this.state.last_name)
    };

    render = () => {
        return (
            <Modal
                style={styleContact}
                aria-labelledby="Cambio cuenta"
                open={true}
                onClose={this.props.onClose}
            >
                <ClickAwayListener onClickAway={this.handleClickAway}>
                    <Paper elevation={4}>
                        <div className="text-center">
                            <br></br>
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="h6" gutterBottom>
                                    Datos de contacto
                            </Typography>
                                <Divider />
                                <TextField
                                    error={Boolean(this.state.instagram_error_text)}
                                    placeholder="Instagram"
                                    type="text"
                                    value={this.state.instagram}
                                    
                                    helperText={this.state.instagram_error_text}
                                    onChange={(e) => this.changeValue(e, 'instagram')}
                                />
                                <br></br>
                                <TextField
                                    error={Boolean(this.state.DNI_error_text)}
                                    placeholder="DNI"
                                    type="text"
                                    value={this.state.DNI}
                                    helperText={this.state.DNI_error_text}
                                    onChange={(e) => this.changeValue(e, 'DNI')}
                                />
                                <br></br>
                                <TextField
                                    error={Boolean(this.state.last_name_error_text)}
                                    placeholder="Apelido"
                                    type="text"
                                    onInput={toInputUppercase}
                                    value={this.state.last_name}
                                    helperText={this.state.last_name_error_text}
                                    onChange={(e) => this.changeValue(e, 'last_name')}
                                />
                                <br></br>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={this.state.disabled}
                                    onClick={(e) => this.update(e)}
                                >
                                    Actualizar
                                </Button>
                                <br></br>
                                <br></br>
                            </div>

                        </div>

                    </Paper>
                </ClickAwayListener>
            </Modal >
        )
    }
}

// AccountModal


export class AccountModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            creditChecked: true,
            accountTypes: ['Credito', 'Efectivo'],
            monthlyCredit: true,
            creditType: ["monthly", "weekly"],
            weekDay: null,
            monthDay: 1,
            maxCredit: null,
            modify: false,
            errMsg: null
            

        }
    }
    componentDidMount = () => {
        if (this.props.account.credit_type === 'credito') {

            const unruled = rrulestr(this.props.account.due_date_rule)
            if (unruled.origOptions.bymonthday) {
                this.setState({
                    creditChecked: true,
                    maxCredit: this.props.account.credit_limit,
                    monthlyCredit: true,
                    monthDay: unruled.origOptions.bymonthday
                })

            }
            else {
                this.setState({
                    creditChecked: true,
                    maxCredit: this.props.account.credit_limit,
                    monthlyCredit: false,
                    weekDay: unruled.origOptions.bymonthday
                })
            }
        }
        else {
            this.setState({ creditChecked: false })
        }
        this.setMaxCredit(this.props.account.credit_limit)

    }
    creditCycle = () => {
        if (this.state.monthlyCredit) {
            this.setState({ creditType: 'weekly', monthlyCredit: false })
        }
        else {
            this.setState({ creditType: 'monhtly', monthlyCredit: true })
        }

    }

    switchBilling = (_) => {
        this.setState({ creditChecked: !this.state.creditChecked })
    }

    weeklyCredit = (event) => {
        this.setState({ weekDay: event.target.value })
    }

    setMonthDay = (event) => {
        let day = event.target.value
        if (!isNaN(day)) {
            if (!day == "" && day <= 0) {
                day = 1
            }
            else if (!day == "" && day >= 31) {
                day = 30
            }
            this.setState({ monthDay: day })
        }
    }

    handleClickAway = () => {
        this.props.onClose();
    };

    setMaxCredit = (amount) => {
        if(this.props.account.balance > amount){
            this.setState({maxCredit: amount, modify: false, errMsg: 'Monto menor al balance actual'})
        }else{
            this.setState({ maxCredit: amount, errMsg: '', modify: true })
        }
    }   

   
    updateAccount = () => {
        const data = {'account': this.props.account.id,
                     'credit_limit': parseInt(this.state.maxCredit),
                     'credit_type': 'efectivo'
                     }
        if(this.state.creditChecked){
            const due_date_rule = this.state.monthlyCredit?
            "FREQ=MONTHLY;BYMONTHDAY=" + this.state.monthDay :
            "FREQ=WEEKLY;BYWEEKDAY=" + this.state.weekDay
            data['due_date_rule'] = due_date_rule   
            data['credit_type'] = 'credito' 
        }
        UserApi.updateAccount(data)
        .then(_ =>{
            this.props.updateAccount()

        })
        .catch(error =>{
            console.log(error)
        })
    }
   
    

    render = () => {
        return (
            <Modal
                style={styleAccount}
                aria-labelledby="Cambio cuenta"
                aria-describedby="simple-modal-description"
                open={true}
                onClose={this.props.onClose}
            >
                <ClickAwayListener onClickAway={this.handleClickAway}>
                    <Paper elevation={4} tabIndex={-1}>
                        <div className='text-center'>
                        <br></br>
                            <div className='text-center' style={{ marginTop: 10 }}>
                                <Typography variant="h6" gutterBottom>
                                    Datos de la cuenta
                                </Typography>
                                <Divider />
                            </div>

                            <form role="form">
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={this.state.creditChecked}
                                                onChange={this.switchBilling}
                                                color="primary"

                                            />
                                        }
                                        label={this.state.creditChecked ?
                                            this.state.accountTypes[0] : this.state.accountTypes[1]}
                                    />
                                </FormGroup>

                                {this.state.creditChecked && <FormGroup row >
                                    <FormControl component="fieldset">
                                        <RadioGroup aria-label="position" name="position"
                                            value={this.state.monthlyCredit ? "Mensual" : "Semanal"}
                                            onChange={this.creditCycle} row>
                                            <FormControlLabel
                                                value="Mensual"
                                                control={<Radio color="primary" />}
                                                label="Mensual"
                                                labelPlacement="start"
                                            />
                                            <FormControlLabel
                                                value="Semanal"
                                                control={<Radio color="primary" />}
                                                label="Semanal"
                                                labelPlacement="start"
                                            />

                                        </RadioGroup>
                                    </FormControl>

                                    {this.state.monthlyCredit ?
                                        <div className='col-md-10'>
                                            <TextField
                                                id="monthDay"
                                                label="Dia de cierre"
                                                value={this.state.monthDay}
                                                onChange={this.setMonthDay}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                type="number"
                                            />
                                        </div>

                                        :
                                        <div className='col-md-10'>
                                            <FormControl component="fieldset">
                                                <RadioGroup aria-label="position" name="position"
                                                    value={this.state.weeekDay}
                                                    onChange={this.weeklyCredit} row>
                                                    <FormControlLabel
                                                        value="SU"
                                                        control={<Radio color="primary" />}
                                                        label="D"
                                                        labelPlacement="start"
                                                    />
                                                    <FormControlLabel
                                                        value="MO"
                                                        control={<Radio color="primary" />}
                                                        label="L"
                                                        labelPlacement="start"
                                                    />
                                                    <FormControlLabel
                                                        value="TU"
                                                        control={<Radio color="primary" />}
                                                        label="M"
                                                        labelPlacement="start"
                                                    />
                                                    <FormControlLabel
                                                        value="WE"
                                                        control={<Radio color="primary" />}
                                                        label="M"
                                                        labelPlacement="start"
                                                    />
                                                    <FormControlLabel
                                                        value="TH"
                                                        control={<Radio color="primary" />}
                                                        label="J"
                                                        labelPlacement="start"
                                                    />
                                                    <FormControlLabel
                                                        value="FR"
                                                        control={<Radio color="primary" />}
                                                        label="V"
                                                        labelPlacement="start"
                                                    />
                                                    <FormControlLabel
                                                        value="SA"
                                                        control={<Radio color="primary" />}
                                                        label="S"
                                                        labelPlacement="start"
                                                    />

                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    }
                                  
                                </FormGroup>

                                }
                                <div className='col-md-10'>
                                    <TextField
                                        label="Monto maximo"
                                        value={this.state.maxCredit}
                                        onChange={(e) => this.setMaxCredit(e.target.value)}
                                        error={this.state.errMsg?true:false}
                                        helperText={this.state.errMsg}
                                        id="maxCredit"
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}
                                    />

                                </div>
                                <FormGroup row>
                                    <Divider />
                                </FormGroup>
                            </form>
                            <div className=' text-center' style={{ paddingBottom: 30 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.updateAccount}
                                    disabled={!this.state.modify}
                                >
                                Modificar
                                </Button>
                            </div>
                        </div>
                    </Paper>
                </ClickAwayListener>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Customer/EditCustomer.js